module.exports = __webpack_public_path__ + "static/intercom-a53313676fa5955ec65d8594f5fb41a4.png";